export const Constants = Object.freeze({
    Practice_Site_MasterSheet_Range: "A1:D2000",
    Practice_Site_MasterSheet_Name: "Practices and Sites Info",
    Practice_Site_WriteSheet_Name: "Users",
    SITE_PRACTICE_COLUMNS: {
        PRACTICE_NAME: 6, // G
        SITE_NAME: 7, // H
        PRACTICE_ID: 8, // I
        SITE_ID: 9, // J
    },
    Roles_MasterSheet_Name: "roles",
    Roles_MasterSheet_Range: "A1:B100",
    ROLE_COLUMNS: {
        ROLE_NAME: 5, // F
        ROLE_ID: 10, // K
    },
    MAX_ROWS_WRITE: 1000,
});
